import Hero from '../Hero';
import Features from '../Features';
import Contact from './Contact';
import WorkingAreas from '../WorkingAreas';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Staffing from '../stuffing';
function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToContact) {
      const el = document.getElementById('contact');
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 100); // delay to ensure DOM is ready
      }
    }
  }, [location]);
  
  return (
    <>
      <Hero />
       <Staffing/>
     
      <WorkingAreas />
       <Features />
   
      <div id="contact">
        <Contact />
      </div>
    </>
  );
}

export default Home;
